<template>
  <div>
    <v-autocomplete
      v-model="selectedProduct"
      hide-no-data
      ref="productSearchInput"
      @keyup.enter="searchIMEI"
      outlined
      :loading="productSearchLoading"
      prepend-inner-icon="search"
      :rounded="rounded"
      allow-overflow
      dense
      single-line
      :error-messages="error"
      :hide-details="error.length === 0"
      clearable
      eager
      id="productSearch"
      :items="Products"
      item-text="name"
      return-object
      :search-input.sync="phoneSearch"
      :label="$t('labels.searchProduct')"
      :items-per-page="20"
      :filter="customFilter"
    >
      <template v-slot:prepend-item>
        <v-list-item ripple @click="openMultipleProductsDialog">
          <v-list-item-content>
            <v-list-item-title>Choose Multiple Items</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mb-1"></v-divider>
      </template>

      <template v-slot:item="{ item }">
        <div class="d-flex justify-space-between align-center w-100">
          <div>
            <div v-html="$highlight(item.name, phoneSearch)"></div>
            <div class="grey--text text--darken-1 text-caption" v-if="item.sku">
              SKU: <span v-html="$highlight(item.sku, phoneSearch)"></span>
            </div>
            <small v-if="item.dynamicPrice === item.price" class="red--text">
              {{ item.dynamicPrice | currency }} *
            </small>
            <small v-else>
              {{ item.price | currency }}
              <v-icon small class="ml-1" v-if="currentUser.priceMarkupStatus"
                >mdi-sale</v-icon
              >
            </small>
          </div>

          <v-chip
            v-if="item.trackInventory"
            :color="item.trackSerialNumber ? 'light-primary' : 'teal darken-1'"
            dark
          >
            <v-avatar
              left
              class="light-blue darken-2"
              v-if="item.trackSerialNumber"
            >
              <v-icon small>mdi-barcode-scan</v-icon>
            </v-avatar>
            <v-avatar left v-else class="teal darken-3">
              <v-icon small>mdi-package-variant-closed</v-icon>
            </v-avatar>
            <span>{{ item.balance }}</span>
          </v-chip>
        </div>
      </template>
    </v-autocomplete>

    <v-dialog v-model="multipleProductsDialog" width="550">
      <v-card>
        <ModelTitle title="Add Items" @close="closeMultipleProductsDialog()" />
        <v-container class="pa-5" grid-list-lg>
          <v-layout row wrap justify-center align-center>
            <v-text-field
              v-if="!selectedProducts.length"
              v-model="searchProduct"
              outlined
              prepend-inner-icon="search"
              rounded
              dense
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
            <v-spacer v-if="selectedProducts.length"></v-spacer>
            <v-btn
              color="info"
              v-if="selectedProducts.length"
              @click="addToCart"
            >
              Add To Cart</v-btn
            >
            <v-list class="list-350">
              <template v-for="(product, index) in NonSerializedProducts">
                <v-list-item :key="index">
                  <v-list-item-action>
                    <v-checkbox
                      v-model="product.selected"
                      @click="productSelected(product)"
                      hide-details=""
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ product.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      product.price | currency
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action v-if="product.selected">
                    <v-flex shrink class="ma-0">
                      <v-btn
                        dark
                        fab
                        x-small
                        color="red"
                        depressed
                        @click.stop.prevent="decrementQuantity(product)"
                      >
                        <v-icon>mdi-minus-thick</v-icon>
                      </v-btn>
                      {{ product.qty }}
                      <v-btn
                        dark
                        fab
                        x-small
                        color="info"
                        depressed
                        @click.stop.prevent="incrementQuantity(product)"
                      >
                        <v-icon>mdi-plus-thick</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-list-item-action>
                </v-list-item>
                <!-- <v-divider v-if="index + 1 < Products.length" :key="index"> -->
                <!-- </v-divider> -->
              </template>
            </v-list>
          </v-layout>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="info"
            :disabled="!cartProducts.length"
            @click="submitMultiple"
          >
            Add {{ cartProducts.length }}
            {{ cartProducts.length > 1 ? "Items" : "Item" }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Products: {{ Products }} -->
  </div>
</template>

<script>
import productService from "@/modules/Product/service";
import { mapGetters, mapActions } from "vuex";
import purchaseService from "@/modules/Inventory/Purchase/service";
import PriceTierService from "@/modules/Product/PriceTier/service.js";
import CustomerPriceService from "@/modules/Customer/CustomerPrice/service.js";

export default {
  name: "product-autocomplete",
  props: {
    autofocus: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    PriceTierId: {
      type: [Number, String],
      default: null,
    },
    nonSerialized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: null,
      PriceTiers: [],
      error: [],
      Products: [],
      selectedProduct: null,
      NonSerializedProducts: [],
      search: null,
      productSearchLoading: false,
      multipleProductsDialog: false,
      selectedProducts: [],
      phoneSearch: null,
      cartProducts: [],
      searchProduct: null,
    };
  },
  created() {
    if (
      !this.currentBusiness?.metadata?.isSingleCustomerPricing &&
      this.PriceTierId
    ) {
      return PriceTierService.getById(this.PriceTierId).then((response) => {
        this.loading = false;
        // console.log("PriceTierId response", response, val);
        this.PriceTiers = response.data;
        return response;
      });
    }
  },
  watch: {
    PriceTierId(val) {
      if (!this.currentBusiness?.metadata?.isSingleCustomerPricing && val) {
        return PriceTierService.getById(val).then((response) => {
          this.loading = false;
          // console.log("PriceTierId response", response);
          this.PriceTiers = response.data;
          return response;
        });
      }
    },
    // selectedProduct(val) {
    //   if (val) {
    //     // console.log("selectedProduct", val, this.getSelectedCustomer, this.PriceTiers);
    //     if (!this.currentBusiness?.metadata?.isSingleCustomerPricing && this.PriceTiers) {
    //       // Percentage discount
    //       if (
    //         this.PriceTiers.discountType === "percentage" &&
    //         this.PriceTiers.rate
    //       ) {
    //         // Reduce val.price by percentage
    //         val.price = +(
    //           val.price -
    //           (val.price * this.PriceTiers.rate) / 100
    //         ).toFixed(2);
    //       }
    //       if (
    //         this.PriceTiers.discountType === "fixed" &&
    //         Array.isArray(this.PriceTiers.ProductPrices)
    //       ) {
    //         const productPrice = this.PriceTiers.ProductPrices.find(
    //           (p) => p.ProductId === val.id
    //         );
    //         if (productPrice) {
    //           val.price = productPrice.price;
    //         }
    //       }
    //     }
    //     if(this.currentBusiness?.metadata?.isSingleCustomerPricing){
    //       return CustomerPriceService.getAll({ProductId: val.id, CustomerId: this.getSelectedCustomer.id}).then((response) => {
    //         console.log("CustomerPriceService response", response);
    //         let CustomerPrice = response.data[0];
    //         val.price = CustomerPrice.price
    //         this.$emit("submit", val);
    //       });
    //     }
    //     this.$emit("submit", val);
    //   }
    // },
    async selectedProduct(val) {
      if (!val) return;

      // Work on a copy (optional, but avoids unintended mutation side-effects)
      const product = { ...val };

      // Apply tier-based pricing when NOT in single-customer pricing mode
      if (
        !this.currentBusiness?.metadata?.isSingleCustomerPricing &&
        this.PriceTiers
      ) {
        const tiers = this.PriceTiers;

        // Percentage discount
        if (tiers.discountType === "percentage" && tiers.rate) {
          const priceNum = Number(product.price) || 0;
          const rateNum = Number(tiers.rate) || 0;
          product.price = Number(
            (priceNum - (priceNum * rateNum) / 100).toFixed(2)
          );
        }

        // Fixed (per‑product) price
        if (
          tiers.discountType === "fixed" &&
          Array.isArray(tiers.ProductPrices)
        ) {
          const productPrice = tiers.ProductPrices.find(
            (p) => Number(p.ProductId) === Number(product.id)
          );
          if (productPrice && productPrice.price != null) {
            product.price = productPrice.price;
          }
        }
      }

      // Single-customer pricing path
      if (this.currentBusiness?.metadata?.isSingleCustomerPricing) {
        const customer = this.getSelectedCustomer;
        if (!customer || !customer.id) {
          // No selected customer — just submit what we have
          this.$emit("submit", product);
          return;
        }

        try {
          const response = await CustomerPriceService.getAll({
            ProductId: product.id,
            CustomerId: customer.id,
          });

          const rows = Array.isArray(response?.data) ? response.data : [];
          const cp = rows[0];

          if (cp && cp.price != null) {
            product.price = cp.price;
          }
          // If no custom price found, keep whatever price is already on product
        } catch (err) {
          // Log and fall back to the price we already computed
          console.error("CustomerPriceService error", err);
        }

        this.$emit("submit", product);
        return;
      }

      // Default emit (non single-customer path)
      this.$emit("submit", product);
    },
    phoneSearch(val) {
      if (val && val.length > 2) {
        this.getProduct();
      }
      // if (val && val.length > 1) this.error = [];
    },
    searchProduct(val) {
      this.fetchNonSerializedProducts();
    },
  },
  computed: {
    ...mapGetters("invoice", [
      "Invoice",
      "InvoiceDetails",
      "getSelectedCustomer",
    ]),
    ...mapGetters("global", ["currentUser", "currentBusiness"]),
  },
  methods: {
    ...mapActions("invoice", ["AddInvoiceDetail"]),
    ...mapActions("global", ["PlaySound"]),
    incrementQuantity(product) {
      product.qty++;
      if (product.qty > 100) product.qty = 100; // Limit to 100
    },
    decrementQuantity(product) {
      product.qty--;
      if (product.qty < 1) product.qty = 1; // Limit to minimum
    },
    // customFilter(item, queryText) {
    //   if (!queryText) return true;
    //   const terms = queryText.split(" ").filter(Boolean); // Split input by spaces
    //   const regex = new RegExp(
    //     terms.map((term) => `(?=.*${term})`).join(""),
    //     "i"
    //   ); // RegExp to match terms in any order
    //   return regex.test(item.name);
    // },
    customFilter(item, queryText) {
      if (!queryText) return true;

      const terms = queryText.split(" ").filter(Boolean);
      const regex = new RegExp(
        terms.map((term) => `(?=.*${term})`).join(""),
        "i"
      );

      const nameMatch = item.name && regex.test(item.name);
      const skuMatch = item.sku && regex.test(item.sku);

      return nameMatch || skuMatch;
    },
    emptyEntryBar() {
      this.$emit("emptyEntryBar");
      this.selectedProduct = null;
      this.phoneSearch = null;
      // console.log('empty entry bar call')
    },
    emptyAutoComplete() {
      // console.log('emptyAutoComplete')
      this.selectedProduct = null;
    },
    productSelected(val) {
      if (val.selected) this.selectedProducts.push(val);
      else {
        const index = this.selectedProducts.findIndex((x) => x.id === val.id);
        this.selectedProducts.splice(index, 1);
      }
    },
    // getProduct() {
    //   return productService.getAll({ search: this.phoneSearch, hideParent: true }).then((result) => {
    //     const product = result.data;
    //     this.Products = product
    //   });
    // },
    // getProduct() {
    //   return productService
    //     .getAll({ search: this.phoneSearch, hideParent: true })
    //     .then((result) => {
    //       console.log('product search result: ',this.phoneSearch, result)
    //       const product = result.data;
    //       if (this.currentUser.priceMarkupStatus) {
    //         product.forEach((row) => {
    //           const base = parseFloat(row.price) || 0;
    //           const pct = parseFloat(this.currentUser.priceMarkup) || 0;
    //           // newPrice = base + (base * pct / 100)
    //           const newPrice = base * (1 + pct / 100);
    //           // round to 2 decimals
    //           row.price = parseFloat(newPrice.toFixed(2));
    //         });
    //       }

    //       // Sort products based on the closeness to the search query
    //       this.Products = product.sort((a, b) => {
    //         const query = this.phoneSearch.toLowerCase();

    //         // Check if the name starts with the search query
    //         const aStartsWith = a.name.toLowerCase().startsWith(query) ? 0 : 1;
    //         const bStartsWith = b.name.toLowerCase().startsWith(query) ? 0 : 1;

    //         // Prioritize products whose name starts with the search query
    //         if (aStartsWith !== bStartsWith) {
    //           return aStartsWith - bStartsWith;
    //         }

    //         // If both start or neither starts, use indexOf to check proximity
    //         const aIndex = a.name.toLowerCase().indexOf(query);
    //         const bIndex = b.name.toLowerCase().indexOf(query);

    //         if (aIndex !== bIndex) {
    //           return aIndex - bIndex; // Closer to the start gets higher priority
    //         }

    //         // Finally, sort alphabetically if all else is equal

    //         return a.name.localeCompare(b.name);
    //       });
    //     });
    // },
    getProduct() {
      let where = {
        search: this.phoneSearch, 
        hideParent: true
      }

      if(this.nonSerialized){
        where.inventoryType = "nonSerialize"
      }
      return productService
        .getAll(where)
        .then((result) => {
          const product = result.data;
          if (this.currentUser.priceMarkupStatus) {
            product.forEach((row) => {
              const base = parseFloat(row.price) || 0;
              const pct = parseFloat(this.currentUser.priceMarkup) || 0;
              row.price = parseFloat((base * (1 + pct / 100)).toFixed(2));
            });
          }

          const query = this.phoneSearch.toLowerCase();
          this.Products = product
            .filter((item) => item.name || item.sku)
            .sort((a, b) => {
              const aMatch =
                a.name?.toLowerCase().startsWith(query) ||
                a.sku?.toLowerCase().startsWith(query);
              const bMatch =
                b.name?.toLowerCase().startsWith(query) ||
                b.sku?.toLowerCase().startsWith(query);
              if (aMatch && !bMatch) return -1;
              if (!aMatch && bMatch) return 1;
              return (a.name || "").localeCompare(b.name || "");
            });
        });
    },
    fetchNonSerializedProducts() {
      if (this.searchProduct && this.searchProduct.length < 3) {
        return productService
          .getAll({
            limit: 50,
            hideParent: true,
            inventoryType: "nonSerialize",
          })
          .then((result) => {
            this.NonSerializedProducts = [];
            const products = result.data;
            products.map((row) => {
              row.selected = false;
              row.qty = 1;
              this.NonSerializedProducts.push(row);
            });
          });
      } else {
        return productService
          .getAll({
            hideParent: true,
            inventoryType: "nonSerialize",
            search: this.searchProduct,
          })
          .then((result) => {
            this.NonSerializedProducts = [];
            const products = result.data;
            products.map((row) => {
              row.selected = false;
              row.qty = 1;
              this.NonSerializedProducts.push(row);
            });
          });
      }
    },
    addToCart() {
      if (!this.selectedProducts.length) return false;
      this.selectedProducts.map((product) => {
        product.Bar = {
          name: product.name,
          qty: product.qty,
          price: product.price,
          boxQty: product.qty,
        };
        this.cartProducts.push(product);
      });
      this.selectedProducts = [];
      this.NonSerializedProducts.map((row) => {
        row.selected = false;
        row.qty = 1;
      });
    },
    submitMultiple() {
      // console.log("submitMultiple", this.cartProducts);
      if (!this.cartProducts.length) return false;
      this.$emit("submitMultiple", this.cartProducts);
      this.closeMultipleProductsDialog();
    },
    openMultipleProductsDialog() {
      this.multipleProductsDialog = true;
      this.fetchNonSerializedProducts();
    },
    closeMultipleProductsDialog() {
      (this.multipleProductsDialog = false),
        (this.cartProducts = []),
        (this.NonSerializedProducts = []),
        (this.selectedProducts = []),
        (this.searchProduct = null);
    },
    async searchIMEI() {
      this.error = [];
      if (!this.phoneSearch) return false;
      if (this.selectedProduct) return false;

      const searchValue = {
        imeiNumber: this.phoneSearch,
      };

      const imeiResult = this.InvoiceDetails.findIndex((row) => {
        // // console.log('searchValue.imeiNumber', searchValue.imeiNumber)
        // // console.log(
        //   "searchValue.imeiNumber",
        //   row,
        //   searchValue.imeiNumber.toUpperCase()
        // );
        if (row.imeiNumber) row.imeiNumber = row.imeiNumber.toUpperCase();
        if (searchValue.imeiNumber)
          searchValue.imeiNumber = searchValue.imeiNumber.toUpperCase();
        if (row.imeiNumber === searchValue.imeiNumber) {
          return true;
        }
      });
      // console.log("passed!", imeiResult); //355299070455844

      if (imeiResult !== -1) {
        if (this.InvoiceDetails[imeiResult].delete) {
          await this.UnDeleteInvoiceDetailRow(imeiResult);
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Item was restore",
            });

          this.emptyEntryBar();
          return false;
        }
        this.error.push(`${searchValue.imeiNumber} is already in this list`);
        this.productSearchLoading = false;
        this.PlaySound("error");
        // this.$swal
        //   .mixin({
        //     toast: true,
        //     position: "top-right",
        //     showConfirmButton: true,
        //     timer: 3000,
        //   })
        //   .fire({
        //     icon: "error",
        //     title: `${searchValue.imeiNumber} is already in this list`,
        //   });
        this.$swal({
          title: "Product Not Found",
          text: `${searchValue.imeiNumber} is already in this list`,
          icon: "warning",
        });
        this.emptyEntryBar();
      } else {
        // console.log('i am here')
        this.productSearchLoading = true;
        // console.log('searching for upc code', searchValue)
        searchValue.filteredStatus = ["repair", "onHold", "available"];
        return purchaseService
          .search(searchValue)
          .then(async (response) => {
            console.log("response imei number", response);
            if (response.data) {
              if (response.data.status === "repair") {
                this.error.push(
                  `${this.phoneSearch} is on repair please bring it on available before you can sell it`
                );
                this.productSearchLoading = false;
                this.PlaySound("error");
                this.$swal({
                  title: "Status On Repair",
                  text: `${this.phoneSearch} is on repair please bring it on available before you can sell it`,
                  icon: "warning",
                });
                return true;
              }
              if (response.data.status === "onHold") {
                this.error.push(
                  `${this.phoneSearch} is on hold please bring it on available before you can sell it`
                );
                this.productSearchLoading = false;
                this.PlaySound("error");
                this.$swal({
                  title: "Status On Hold",
                  text: `${this.phoneSearch} is on hold please bring it on available before you can sell it`,
                  icon: "warning",
                });
                return true;
              }
              this.productSearchLoading = false;
              let product = response.data;
              // product.Product = response.data.Product
              product.Product.imeiNumber = this.phoneSearch;
              // // console.log("response.data", response.data);
              // this.selectedProduct = response.data.Product;
              //     this.selectedProduct.Bar = {
              //   name: this.name,
              //   qty: this.qty,
              //   price: this.price,
              //   boxQty: this.boxQty,
              // };
              // console.log('product', product)

              this.AddInvoiceDetail({
                ProductId: product.Product.id,
                name: product.Product.name,
                price: product.Product.price,
                total: product.Product.price * 1,
                qty: 1,
                boxQty: 1,
                // unitCountInBox: product.Product.unitCountInBox,
                cost: product.cost | 0,
                imeiNumber: product.imeiNumber,
              });

              this.emptyEntryBar();
            } else {
              const upcProduct = (
                await productService.upcSearch({ upc: this.phoneSearch })
              ).data;

              if (upcProduct) {
                console.log("found upcProduct", upcProduct);
                let total = 0;
                // if (upcProduct.unitCountInBox && upcProduct.unitCountInBox > 0 && this.currentBusiness?.metadata?.boxCountOnInventory) {
                //   total = ((1 * upcProduct.unitCountInBox) * upcProduct.boxPrice).toFixed(2)
                //   total = parseFloat(total)
                // } else {
                //   total = upcProduct.price * 1
                // }
                if (this.currentBusiness?.metadata?.UPCbehave) {
                  total = upcProduct.price * upcProduct.unitCountInBox;
                  this.AddInvoiceDetail({
                    ProductId: upcProduct.id,
                    name: upcProduct.name,
                    price: upcProduct.price,
                    total: total,
                    qty: upcProduct.unitCountInBox,
                    boxQty: 1,
                    unitCountInBox: upcProduct.unitCountInBox,
                    cost: upcProduct.cost | 0,
                  });
                  this.emptyEntryBar();
                  this.productSearchLoading = false;
                } else {
                  // this.selectedProduct = upcProduct
                  this.productSearchLoading = false;
                  this.$emit("submit", upcProduct);
                  this.selectedProduct = upcProduct;
                  // this.$refs.qty.focus
                }
                // C75334982222
              } else {
                this.error.push(
                  `${this.phoneSearch} No Product with this search`
                );
                this.productSearchLoading = false;
                this.PlaySound("error");
                // this.$swal
                //   .mixin({
                //     toast: true,
                //     position: "top-right",
                //     showConfirmButton: true,
                //     timer: 3000,
                //   })
                //   .fire({
                //     icon: "error",
                //     title: `${this.phoneSearch} No Product with this serach`,
                //   });
                this.$swal({
                  title: "Product Not Found",
                  text: `${this.phoneSearch} No Product with this serach`,
                  icon: "warning",
                });
                this.emptyEntryBar();
              }
            }
          })
          .catch((error) => {
            this.productSearchLoading = false;
            this.error.push(`${this.phoneSearch} No Product with this search`);
            this.productSearchLoading = false;
            this.PlaySound("error");
            this.$swal({
              title: "Product Not Found",
              text: `${this.phoneSearch} No Product with this serach`,
              icon: "warning",
            });
            // this.$swal
            //   .mixin({
            //     toast: true,
            //     position: "top-right",
            //     showConfirmButton: true,
            //     timer: 3000,
            //   })
            //   .fire({
            //     icon: "error",
            //     title: `${this.phoneSearch} No Product with this serach`,
            //   });
            console.log("error", error);
          });
      }
    },
  },
};
</script>

<style scoped></style>